export const DEFAULT_WIDGET_FONT =
  '"Avenir-LT-W01_35-Light1475496", sans-serif';
